jQuery_T4NT(document).ready(function($) {
document.querySelectorAll('#CustomSizeTab input').forEach((ele) => {
  ele.addEventListener("input", function () {
    if (this.value < 0) {
        this.value = 0;
    }
  });
});

  
const cartFusionVariantPre = document.querySelector(`.cartFusion_fbt_item select option[value="${window.location.search.split('=').pop()}"]`);
if (cartFusionVariantPre) {
  cartFusionVariantPre.selected = true;

  if (cartFusionVariantPre.disabled === true) {
    // console.log('soldout')
    document.querySelector('.cartFusion_fbt_action_control').style.display = 'none';
    document.querySelector('.cartFusion_fbt_action_trigger').style.display = 'none';
    document.querySelector('.soldOutButton').removeAttribute('hidden');
  } else {
    // console.log('instock')
    document.querySelector('.cartFusion_fbt_action_control').style.display = 'block';
    document.querySelector('.cartFusion_fbt_action_trigger').style.display = 'block';
    document.querySelector('.soldOutButton').setAttribute('hidden', '');
  }
}

$( document ).on( "variant:changed", function( evt ) {
// document.querySelector(.cartFusion_fbt_item select option[value="${evt.currentVariant.id}"]).selected = true;
const cartFusionVariant = document.querySelector(`.cartFusion_fbt_item select option[value="${evt.currentVariant.id}"]`);

if (cartFusionVariant) {
  cartFusionVariant.selected = true;

  if (cartFusionVariant.disabled === true) {
    // console.log('soldout')
    document.querySelector('.cartFusion_fbt_action_control').style.display = 'none';
    document.querySelector('.cartFusion_fbt_action_trigger').style.display = 'none';
    document.querySelector('.soldOutButton').removeAttribute('hidden');
  } else {
    // console.log('instock')
    document.querySelector('.cartFusion_fbt_action_control').style.display = 'block';
    document.querySelector('.cartFusion_fbt_action_trigger').style.display = 'block';
    document.querySelector('.soldOutButton').setAttribute('hidden', '');
  }
}


// const fbtPPS = evt.target.querySelector(#parentProduct select option[data-variantcon="${evt.currentVariant.title}"]);
// const wrapperHide = document.querySelector('.sr4-fbt__products .sr4-quantity-wrapper');
// const fbtSubmitBTN = document.querySelector('.sr4-fbt__submit');
// const fbtSubmit = document.querySelector('.sr4-fbt__submit .sr4-btn-atc_text');
// // if (fbtPPS) {
//   fbtPPS.selected = true;
//   wrapperHide.style.display = "block";
//   fbtSubmit.innerHTML = 'ADD TO CART';
//   fbtSubmitBTN.disabled = false ;
// } else{
//   wrapperHide.style.display = "none";
//   fbtSubmit.innerHTML = 'Out of Stock';
//   fbtSubmitBTN.disabled = true ;
// } 
})

$(document).on("variant:changed", function (evt) {
  // console.log(evt.currentVariant.title);
  if (evt.currentVariant.title.includes('Customised')) {
      document.querySelectorAll('#CustomSizeTab input').forEach((ele) => {
          ele.removeAttribute("disabled");
      });
      document.querySelectorAll(`.cartFusion_fbt_wrapper input.fbt_properties.customize_properties`).forEach((cartFusionPro)=>{
          cartFusionPro.removeAttribute("disabled");
      })
    } else {
      document.querySelectorAll('#CustomSizeTab input').forEach((ele) => {
        ele.setAttribute("disabled", "disabled");
      });
      document.querySelectorAll(`.cartFusion_fbt_wrapper input.fbt_properties.customize_properties`).forEach((cartFusionPro)=>{
          cartFusionPro.setAttribute("disabled", "disabled");
      })
  };
});
document.querySelectorAll('#CustomSizeTab input').forEach((inp)=>{
    inp.addEventListener('input',()=>{
        document.querySelector(`.cartFusion_fbt_wrapper input[id="${inp.id}"]`).value = inp.value;
    })
})
});
